import React from "react";
import { BarLoader } from "react-spinners";

// Default logo URL
const Logo = "https://assets.transak.com/images/website/transak-logo.svg";

// The Loader component displays a loading spinner along with an optional logo.
const Loader = ({ color = "#1461DB", logo = Logo }) => {
  return (
    // Overlay the entire screen with a semi-transparent background
    <div className="w-full h-full fixed top-0 left-0 bg-white opacity-75 z-50">
      <div className="flex flex-col justify-center items-center mt-[45vh] gap-3">
        {/* Display the provided logo */}
        <img className="mx-auto h-10 w-auto" src={logo} alt="partner_logo" height={20} width={100} />
        {/* Display a loading spinner with the provided color */}
        <BarLoader color={color} />
      </div>
    </div>
  );
};

export default Loader;
